export default (text) => {
  return String(text).replace(/[！-～]/g, function(all) {
    return String.fromCharCode(all.charCodeAt(0) - 0xFEE0);
  });
}
